document.querySelectorAll('.card.toggle').forEach((card) => {
  card.onclick = function () {
    card.classList.toggle('active')
    var parentContainer = card.closest('.bundle')
    var bundle_count = parentContainer.querySelectorAll('.card.active').length
    var bundle_price = 0
    var button = parentContainer.querySelector('.bundle__button')
    var count = parentContainer.querySelector('.bundle__button span.count')
    var count2 = parentContainer.querySelector('.bundle__button span.count2')
    var price = parentContainer.querySelector('.bundle__button span.price')
    var enabled = parentContainer.querySelector('.bundle__button span.enabled')
    var added = parentContainer.querySelector('.bundle__button span.added')
    var disabled = parentContainer.querySelector(
      '.bundle__button span.disabled'
    )
    var s = parentContainer.querySelector('.bundle__button span.s')
    var s2 = parentContainer.querySelector('.bundle__button span.s2')

    enabled.style.display = 'inline'
    added.style.display = 'none'

    parentContainer.querySelectorAll('.card.active').forEach((card) => {
      var price = card.dataset.price
      bundle_price = +bundle_price + +price
    })

    count.innerHTML = bundle_count
    count2.innerHTML = bundle_count
    price.innerHTML = bundle_price.toFixed(2)

    if (bundle_count > 1 || bundle_count == 0) {
      s.style.display = 'inline'
      s2.style.display = 'inline'
    } else {
      s.style.display = 'none'
      s2.style.display = 'none'
    }

    if (bundle_count == 0) {
      button.classList.add('disabled')
      enabled.style.display = 'none'
      disabled.style.display = 'inline'
    } else {
      button.classList.remove('disabled')
      enabled.style.display = 'inline'
      disabled.style.display = 'none'
    }
  }
})

if (document.querySelector('.bundle__button')) {
  document
    .querySelector('.bundle__button')
    .addEventListener('click', function (e) {
      const variants = []
      var parentContainer = this.closest('.bundle')
      // prevent default shopify add to cart functionality
      e.preventDefault()
      e.stopPropagation()

      this.querySelector('span.adding').style.display = 'flex'
      this.querySelector('span.enabled').style.display = 'none'
      this.querySelector('span.added').style.display = 'none'

      parentContainer.querySelectorAll('.card.active').forEach((card) => {
        variants.push({
          id: card.dataset.id,
          quantity: 1,
        })
      })

      const formData = {
        items: variants,
      }

      //console.log(variants);
      //console.log(formData);

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      })
        .then((response) => {
          return response.json()
        })
        .then(() => {
          const miniCart = document.getElementById('mini-cart')
          const miniCartOverlay = document.getElementById('mini-cart-overlay')
          miniCart.classList.add('open')
          miniCartOverlay.classList.add('open')

          this.querySelector('span.added').style.display = 'block'
          this.querySelector('span.adding').style.display = 'none'
        })
        .catch((error) => {
          console.error('Error:', error)
        })
    })
}
